import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Page from '~/components/page/page';
import Tank from '~/containers/tank/tank';

export class TankPage extends Component {
  render() {
    const tankId = this.props.match.params.tankId;
    return (
      <Page>
        <Tank onCompleted={this.onReceiveTank} id={tankId} />
      </Page>
    );
  }
}

export default withRouter(TankPage);



// WEBPACK FOOTER //
// ./src/pages/tank/tank.jsx